import React, {useLayoutEffect, useRef} from 'react';

export default function PieceList({id, pieces, updateHandler, selected}) {
	const containerRef = useRef(null);

	useLayoutEffect(() => {
		// makes sure the currently selected element is in view and adjusts label so it doesn't overflow
		if (containerRef.current) {
			const selectedElement = containerRef.current.querySelector('li.selected');
			if (selectedElement) {
				const leftLimit = containerRef.current.getBoundingClientRect().left;
				const rightLimit = containerRef.current.getBoundingClientRect().right;
				const label = selectedElement.querySelector('div.label');
				if (label) {
					const labelLeft = label.getBoundingClientRect().left;
					const labelRight = label.getBoundingClientRect().right;
					if (labelLeft < leftLimit) {
						const offset = leftLimit - labelLeft;
						label.style.marginLeft = offset + 'px';
					}
					if (labelRight > rightLimit) {
						const offset = labelRight - rightLimit;
						label.style.marginRight = offset + 'px';
					}
				}
				// try to center selected element in div
				containerRef.current.scrollLeft = selectedElement.offsetLeft - (containerRef.current.clientWidth / 2) +
					(selectedElement.clientWidth / 2);
			}
		}
	}, [selected]);

	return (
		<ul className={'button-list ' + id + '-list'} ref={containerRef}>
			{Object.values(pieces).map((piece, index) =>
				<PieceButton key={index} id={id} piece={piece} selected={selected} updateHandler={updateHandler} />
			)}
			{ id !== 'collection' ? <NoneButton id={id} selected={selected} updateHandler={updateHandler} /> : null }
		</ul>
	)
}

function PieceButton({id, piece, selected, updateHandler}) {
	return (
		<li className={(selected[id] && selected[id].id === piece.id) ? 'selected' : ''}>
			<button className={id + '-button option-button'} style={{backgroundImage: 'url('+piece.image+')'}}
				onClick={e => {
					e.preventDefault();
					updateHandler(id, piece);
					window.dataLayer.push({
						"event": "mix_and_match",
						"event_category": id + " option selection",
						"event_label": piece.label
					});
				}}>
				{piece.label}
			</button>
			<div className="label">{piece.label}</div>
		</li>
	)
}

function NoneButton({id, selected, updateHandler}) {
	return (
		<li className={(selected[id] === null) ? 'selected' : ''}>
			<button className={id + '-button option-button'} style={{backgroundImage: 'url(/images/design-tool/remove.png)'}}
				onClick={e => {
					updateHandler(id, null);
					window.dataLayer.push({
						"event": "mix_and_match",
						"event_category": "option selection",
						"event_label": "none"
					});
				}}>
				None
			</button>
			<div className="label">None</div>
		</li>
	)
}